import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import { request_detail, request_list, update_detail, request_header, remove_detail, create_detail, export_list, upload_file } from '@/commons/hpod';
import Vue from 'vue';
const endpoint = 'deposit'
import configs from '@/configs'
var FileSaver = require('file-saver');
// initial state
const state = {
    loading: false,
    all: {},
    selected: {},
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list(endpoint, res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, `Kygui_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
    getDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa đơn hàng ký gửi.')
            }
            else {
                sendSuccessNotice('Đã xóa đơn hàng ký gửi thành công.')
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setDetail({ commit, dispatch }, {data, params}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if(data.OrderID > 0) {
                    delete data.CreatedDate;
                    delete data.CreatedBy;
                    data.ID = data.OrderID;
                    delete data.OrderID;
                    data.ModifiedBy = this.state.authentication.user.username;
                    update_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể cập nhật đơn hàng ký gửi.')
                            reject(res);
                        }
                        else {
                            sendSuccessNotice('Cập nhật đơn hàng ký gửi thành công.')
                            resolve(res);
                            refreshResource();
                        }
                    }, Vue.http, data, data.ID, this.state.authentication.token);
                }
                else {
                    delete data.CreatedDate;
                    delete data.CreatedBy;            
                    delete data.ID;            
                    delete data.OrderID;
                    data.CreatedBy = this.state.authentication.user.username;
                    create_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể tạo mới đơn hàng ký gửi.')
                            reject(res);
                        }
                        else {
                            sendSuccessNotice('Tạo mới đơn hàng ký gửi thành công.')
                            resolve(res);
                            if(params){
                                dispatch("getList", params);
                            }
                            else {
                                refreshResource();
                            }
                        }
                    }, Vue.http, data, this.state.authentication.token);
                }
            }, 100)
        });
    },
    updateMultiple({ commit }, param) {
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        var req = {
          'OrderIDs': param.OrderIDs,
          'Deliverable': param.Deliverable
        }
        Vue.http.post(`${configs.API}/admin/api/deposit/`, req, header).then(function (res) {
          dispatch('getListOrders', param);
        });
    },
    import_deposit({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason)                    
            }
            else {
                refreshResource();
            }
            
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
    duplicateDetail({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                update_detail(endpoint, res => {
                    commit("setLoading", { loading: false });
                    if (res.data.status === 'fail') {
                        sendErrorNotice('Không thể tạo đơn bổ sung.')
                    }
                    else {
                        sendSuccessNotice('Tạo đơn bổ sung thành công.')
                        resolve(res);
                        refreshResource();
                    }
                }, Vue.http, {'action': 'duplicate'}, id, this.state.authentication.token);
            }, 100)
        });
    }
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
